/**
 * Base JS
 */

// Assuming site header is sticky, add a class to indicate when it's "stuck"
const siteHeader = document.querySelector('.site-header');
let siteHeaderScrollTimeoutId = 0;
window.addEventListener('scroll', () => {
    clearTimeout(siteHeaderScrollTimeoutId);
    siteHeaderScrollTimeoutId = setTimeout(() => {
		siteHeader.classList.toggle('site-header--is-pinned', window.scrollY > 0);
	}, 25);
});

// When clicking on a primary nav link, close the mobile menu
// (because on this site, many of the nav links are anchor links)
// Also, if it's the homepage, trigger the nav pinned style as soon as we click a link
const navStatusElement = document.querySelector('.site-header__mobile-nav-status');
const siteNavlinks = document.querySelector('.site-header__nav-links');
siteNavlinks.addEventListener('click', (e) => {
	navStatusElement.checked = false;
	window.location.pathname == '/' && siteHeader.classList.add('site-header--is-pinned');
});